<template>
    <div>
        <activity-component
            :inEdit="true"
            style="width: 300px"
            :model="localModel">
        </activity-component>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                color="primary"
                @click="save">
                <q-tooltip anchor="top left">
                    Zapisz
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </div>
</template>

<script>
    import ActivityComponent from './ActivityComponent'
    import FixedButtons from './FixedButtons'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'

    export default {
        name: 'ActivityEditor',
        components: {QTooltip, QBtn, FixedButtons, ActivityComponent},
        data () {
            return {
                newModel: {
                    label: 'Nowa aktywność',
                    description: '...',
                    activityTypeId: this.$uuid(),
                    thumbUrl: '',
                },
                localModel: undefined,
            }
        },
        mounted () {
            this.localModel = this.activity || this.newModel

            this.$store.commit('showRightMenu', {
                'showPicture': true,
            })

            this.$on('hook:beforeDestroy', () => {
                this.$store.commit('showRightMenu', false)
            })
        },
        computed: {
            activity () {
                return this.$store.getters.activity.find(a => a.activityTypeId === this.$route.params.activityTypeId)
            },
        },
        methods: {
            save () {
                const method = this.activity ? 'update' : 'create'

                this.$store.dispatch(method, {
                    what: 'activity',
                    item: this.localModel,
                    id: this.localModel.activityTypeId,
                }).then(() => {
                    this.$router.push({name: 'activity-edit', params: {activityTypeId: this.localModel.activityTypeId}})
                })
            },
        },
    }
</script>

<style scoped>

</style>